import { useSelector } from 'react-redux';

import { endOfMonth, formatISO, isFuture, isThisMonth } from 'date-fns';

import { useManualFormValues } from '@asteria/component-form';

import * as AppStore from '@asteria/datalayer/stores/app';

import { getPath } from '../../../utils/getFormPaths';
import { useTransactions } from '../../../utils/operations';

export function useVisibleValue({ type, date, category, tag }) {
	const tagId = useSelector((store) => {
		// TODO: handle this better

		if (tag === '$deposit' || tag === '$withdraw') {
			return null;
		}

		const tags = AppStore.selectors.tags(store);
		const storedTag = tags.find((item) => item?.name === tag);

		return storedTag?._id ?? storedTag?.id ?? '$unknown';
	});

	const historicalValue = useManualFormValues({
		name: getPath({
			type,
			date: formatISO(date, { representation: 'date' }),
			status: 'PAID',
			category,
			tag,
			field: 'value',
		}),
	});

	const transaction = useTransactions(
		{
			type,
			tagId,
			startDate: formatISO(date, { representation: 'date' }),
			endDate: formatISO(endOfMonth(date), {
				representation: 'date',
			}),
		},
		{ includeIntermediate: true },
	);

	if (isFuture(date) || isThisMonth(date)) {
		return transaction.reduce((acc, curr) => acc + curr.payload.total, 0);
	}

	return historicalValue;
}
